<template>
  <div>
    <ClauseRenderer
      class="license-renderer"
      v-for="clause in agreement.clauses"
      :key="clause.id"
      :clause="clause"
      :value="getClauseValue(clause)"
      @input="$event => updateValue({ clause, payload: $event })"
    />
  </div>
</template>

<script>
// @ts-check
import ClauseRenderer from './ClauseRenderer';

/**
 * @type {() => import('@/classes/agreement').Agreement}
 */
const AgreementPropType = Object;

/**
 * @typedef {string[]} ClauseValue
 */
/**
 * @typedef {Record<string, ClauseValue>} ClauseRecordValue
 */
/**
 * @type {() => ClauseRecordValue}
 */
const ValuePropType = Object;

export default {
  components: {
    ClauseRenderer,
  },
  props: {
    agreement: {
      type: AgreementPropType,
      required: true,
    },

    value: {
      type: ValuePropType,
      required: true,
    },
  },

  methods: {
    /**
     * @param {import('@/classes/agreement').Clause} clause
     * @return {ClauseValue}
     */
    getClauseValue(clause) {
      return this.value[clause.code] || [];
    },


    /**
     * @param {{
     *   clause: import('@/classes/agreement').Clause;
     *   payload: ClauseValue
     * }} data
     *
     * @fires #input
     */
    updateValue(data) {
      const { clause, payload } = data;

      /**
       * @event #input
       * @type {ClauseRecordValue}
       */
      this.$emit('input', {
        ...this.value,
        [clause.code]: payload,
      });
    },
  },
};
</script>

<style scoped>
.license-renderer {
  margin-bottom: 48px;
}
</style>


// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppAdditionalAgreements/AgreementRenderer.vue